import React from "react";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";

interface MinicartUSPProps {
  settings: {
    money_back_text?: string;
    show_usp?: boolean;
    money_back_text_style?: string;
    free_shipping_text?: string;
    free_shipping_text_style?: string;
    usp_text_style?: string;
    icon_1?: any; 
    icomoon_icon_1?: string;
    icon_2?: any;
    icomoon_icon_2?: string;
  }
}

export const MinicartUSP = ({ settings }: MinicartUSPProps) => {
  if (!settings?.show_usp) return null;

  const defaultTextStyle = settings?.usp_text_style || 'text-base';
  const moneyBackTextStyle = settings?.money_back_text_style || defaultTextStyle;
  const freeShippingTextStyle = settings?.free_shipping_text_style || defaultTextStyle;
  
  return (
    <div className="minicart__usp rounded-lg my-1">
      <div className="flex items-center justify-between gap-4 Lg;px-[10px]">
        {settings?.money_back_text && (
            <div className="flex items-center">
            {settings.icomoon_icon_1 ? (
              <span className={`${settings.icomoon_icon_1} text-orange-600 mr-1 lg:mr-4  text-base lg:text-[24px]`}></span>
            ) : settings.icon_1 ? (
              <img 
                src={settings.icon_1} 
                alt="Money back guarantee icon"
                className="w-4 h-4 lg:w-6 lg:h-6 mr-1 lg:mr-4"
              />
            ) : (
              <span className="icon-like text-orange-600 mr-1 lg:mr-4 text-base lg:text-[24px]"></span>
            )}
            <Paragraph 
              classes={moneyBackTextStyle} 
              text={settings.money_back_text}
            />
          </div>
        )}
        
        {settings?.free_shipping_text && (
          <div className="flex items-center">
            {settings.icomoon_icon_2 ? (
              <span className={`${settings.icomoon_icon_2} text-orange-600 mr-1 lg:mr-4  text-base lg:text-[24px]`}></span>
            ) : settings.icon_2 ? (
              <img 
                src={settings.icon_2} 
                alt="free shipping icon"
                className="w-4 h-4 lg:w-6 lg:h-6 mr-1 lg:mr-4 "
              />
            ) : (
              <span className="icon-car text-orange-600 mr-1 lg:mr-4  text-base lg:text-[24px]"></span>
            )}
            <Paragraph 
              classes={freeShippingTextStyle} 
              text={settings.free_shipping_text}
            />
          </div>
        )}
      </div>
    </div>
  );
};